import { render, staticRenderFns } from "./SPUAudit.vue?vue&type=template&id=f2d31f3c&scoped=true"
import script from "./SPUAudit.vue?vue&type=script&lang=ts"
export * from "./SPUAudit.vue?vue&type=script&lang=ts"
import style0 from "./SPUAudit.vue?vue&type=style&index=0&id=f2d31f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d31f3c",
  null
  
)

export default component.exports